export const cardActivation = {
    alwaysShowAccountName: false,
};
